import { Flex, Text, useThemeValue } from "@gravity-ui/uikit";
import { motion } from "framer-motion";
import { useEffect, useRef, useState } from "react";
import { appConfig } from "src/config";

import { useHowWeWorkSlides } from "../hooks/useHowWeWorkSlides.tsx";
import css from "../HowWeWork.module.scss";

export const RoadMapSlider = () => {
  const theme = useThemeValue();
  const howWeWorkSlides = useHowWeWorkSlides();

  const sliderRef = useRef<HTMLDivElement>(null);

  const [width, setWidth] = useState(0);

  useEffect(() => {
    const sw = sliderRef?.current?.scrollWidth;
    const ow = sliderRef?.current?.offsetWidth;

    // eslint-disable-next-line react-you-might-not-need-an-effect/no-initialize-state -- меряем DOM (scrollWidth/offsetWidth), доступно только после mount
    setWidth(Number(sw) - Number(ow));
  }, []);

  return (
    <Flex ref={sliderRef} style={{ cursor: "grab" }}>
      <motion.div
        style={{
          display: "flex",
        }}
      >
        <motion.div
          className={css.slidesContainer}
          drag="x"
          dragConstraints={{ right: 0, left: -width }}
          whileTap={{ cursor: "grabbing" }}
        >
          {howWeWorkSlides.map((slide, index, array) => {
            return (
              <Flex
                direction={"column"}
                gap={6}
                height={200}
                width={index === array.length - 1 ? "fit-content" : 400}
                style={{ position: "relative" }}
                key={`howWeWorkSlide_${index}`}
              >
                {index !== array.length - 1 && (
                  <div className={css.slideSeparator} />
                )}

                <appConfig.logo
                  className={css.logo}
                  fill={theme === "dark" ? "white" : "black"}
                  height={38}
                  width={38}
                />
                <Text variant="subheader-3" color="brand">
                  {++index}. {slide.title}
                </Text>
                <Text variant="subheader-1" style={{ maxWidth: 200 }}>
                  {slide.text}
                </Text>
              </Flex>
            );
          })}
        </motion.div>
      </motion.div>
    </Flex>
  );
};
